import Campanha from "../campanha";
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from "config";
import { formatDate } from "../formatos";

const CarrosselCampanhas = ({ lcompanha }) => {
    if (!lcompanha || lcompanha.length === 0) return null;

    return (
      <div className='mt-4'>
        <h2 className='section-title'>Campanhas em Destaque</h2>
        <div className='modern-carousel'>
          <Carousel>
            {lcompanha.map(c => (
              <Carousel.Item key={`camp${c.id_campanha}`}>
                <div className='text-center'>
                  <Campanha
                    descricao={c.den_campanha}
                    banner={`${config.BASEIMG}${c.banner}`}
                    inicio={formatDate(c.validade_ini)}
                    fim={formatDate(c.validade_fim)}
                  />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
    );
  };
  
  export default CarrosselCampanhas;